import StatusEnum from '../Enums/StatusEnum';
import {
  SetFitStatusForAllProducts,
  ResetFitStatusForAllProducts,
  SetFitStatusForConfirmedFits,
  UpdateFitAssistantPriceAndATC,
} from '../../FitAssistantShared/Functions';
import Cookies from 'js-cookie';

export const updateOnFitStatusChange = (fitStatus) => {
  if (fitStatus === StatusEnum.NoSelection) {
    ResetFitStatusForAllProducts();
  } else if (fitStatus === StatusEnum.Unconfirmed) {
    SetFitStatusForAllProducts(StatusEnum.Unconfirmed);
  } else if (fitStatus === StatusEnum.NoFit) {
    SetFitStatusForAllProducts(StatusEnum.NoFit);
  }
};

export const updateProductListingOnRackSelect = (fitStatus, filterClassNames) => {
  let confirmedFitElements = [];
  let confirmedNoFitIds = [];

  const pliElements = document.querySelectorAll('div[data-itemfilters][data-pimid]');
  pliElements.forEach((pliElement) => {
    let fit = false;
    const productId = pliElement.getAttribute('data-pimid');
    filterClassNames.forEach((filterClassName) => {
      if (!fit && pliElement.getAttribute('data-itemfilters').indexOf(filterClassName) > -1) {
        confirmedFitElements.push(pliElement);
        fit = true;
      }
    });
    if (!fit) confirmedNoFitIds.push(productId);
  });

  if (confirmedFitElements.length === 0) {
    SetFitStatusForAllProducts(StatusEnum.NoFit);
    fitStatus = StatusEnum.NoFit;
  } else {
    SetFitStatusForConfirmedFits(confirmedFitElements, confirmedNoFitIds);
    fitStatus = StatusEnum.Confirmed;

    const sortDropdown = document.querySelector('.sort-product-dropdown select');
    if (sortDropdown) sortDropdown.selectedIndex = 0;

    const sortSection = document.querySelector('.sorting-section');
    if (sortSection != null) {
      const event = new CustomEvent('triggerSort', { detail: 'fit' });
      sortSection.dispatchEvent(event);
    }
  }

  return fitStatus;
};

export const updateProductDetailOnRackSelect = (fitStatus, filterInformation) => {
  if (filterInformation.IsFit) {
    fitStatus = StatusEnum.Confirmed;
  } else {
    fitStatus = StatusEnum.NoFit;
  }

  var productId = document.querySelector('#productBuyArea .analytics-data').dataset.pimid;
  var productIds = null;
  const productIdsForSolution = document.querySelector('#productBuyArea .product-ids-for-solution')?.value;
  if (productIdsForSolution) {
    productIds = [filterInformation.AdapterId, ...productIdsForSolution.split(',')];
  } else {
    productIds = [filterInformation.AdapterId, productId].filter((n) => n);
  }
  UpdateFitAssistantPriceAndATC(productIds);

  return fitStatus;
};

export const setCookieData = (data) => {
  Cookies.set('fitGuideRacks', JSON.stringify(data));
};

export const getCookieData = () => {
  var cookie = Cookies.get('fitGuideRacks');

  if (!cookie) return null;

  var data = JSON.parse(cookie);
  return data;
};

export const removeCookieData = () => {
  Cookies.remove('fitGuideRacks');
};
